import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/challengerConversionSaga";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.challengerConversion.currentUser
  );
  const { endDate, startDate } = useSelector(
    (state) => state.challengerConversion.selectedRequestDates
  );

  const updateDates = (startDate, endDate) => {
    dispatch(actionCreators.updateDates({ startDate, endDate }));
  };

  return (
    <ReactDatePicker
      isRangePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      minDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      updateDates={updateDates}
    />
  );
};

export default DatePicker;
